<div>
  <h4 class="db-cdn-disable-enterprise__title">Disable Cloudflare Enterprise</h4>
  <p class="db-cdn-disable-enterprise__desc mt4">You will no longer be able to use Cloudflare Enterprise features.</p>
</div>
<button class="ds-btn-outline-green"  [ngClass]="{'ds-btn-disabled': disableLoading}" (click)="disable()" >
  <span *ngIf="!disableLoading">Disable</span>
  <db-loading-circular-spinner *ngIf="disableLoading"></db-loading-circular-spinner>
</button>
